export default __webpack_public_path__ + "static/media/rob_moodie.82a70a61.jpg";